<template>
  <div class='adjustmentBtn_wrapper' :style="c_style" :class="{'adjustmentBtn_suspend':isSuspends || isMouseenter}">
    <div
      class='adjustmentBtn_wrapper-btn'
      @click="$emit('handleClick',true)"
      @mouseenter="isMouseenter=true"
      @mouseleave="isMouseenter=false">
      {{text}}
    </div>
    <span class='line-1'></span>
    <span class='line-2'></span>
    <span class='line-3'></span>
    <span class='line-4'></span>
  </div>
</template>

<script>
  export default {
    props:{
      text:{
        type:String,
        default:"调整所有标红"
      },
      c_style:{
        type:Object,
        default:()=>{ return {} }
      },
      isSuspends:{
        type:Boolean,
        default:true
      }
    },
    data() {
      return {
        isMouseenter:false
      }
    }
  }
</script>

<style lang="less">
  .adjustmentBtn_suspend{
    .adjustmentBtn_wrapper-btn {
      background: rgba(255, 48, 73, 0.1) !important;
    }
    .line-1,.line-3 {
      height: 100% !important;
      animation:none !important;
    }
    .line-2,.line-4 {
      width: 100% !important;
      animation:none !important;
    }
  }
  .adjustmentBtn_wrapper {
    position: relative;
    display: inline-block;
      &-btn {
        border: none;
        padding: 6px 15px;
        font-size: 12px;
        transition: all .5s;
        box-sizing: border-box;
        cursor: pointer;
        color: #FF3049;
      }

      .line-1 {
          content: "";
          display: block;
          position: absolute;
          width: 1px;
          background-color: #FF3049;
          left: 0;
          bottom: 0;
          animation: move1 1500ms infinite ease;
      }
      .line-2 {
          content: "";
          display: block;
          position: absolute;
          height: 1px;
          background-color: #FF3049;
          left: 0;
          top: 0px;
          animation: move2 1500ms infinite ease;
      }
      .line-3 {
          content: "";
          display: block;
          position: absolute;
          width: 1px;
          background-color: #FF3049;
          right: 0px;
          top: 0;
          animation: move3 1500ms infinite ease;
      }
      .line-4 {
          content: "";
          display: block;
          position: absolute;
          height: 1px;
          background-color: #FF3049;
          right: 0;
          bottom: 0px;
          animation: move4 1500ms infinite ease;
      }
      @keyframes move1 {
          0% {
              height: 100%;
              bottom: 0;
          }
          54% {
              height: 0;
              bottom: 100%;
          }
          55% {
              height: 0;
              bottom: 0;
          }
          100% {
              height: 100%;
              bottom: 0;
          }
      }
      @keyframes move2 {
          0% {
              width: 0;
              left: 0;
          }
          50% {
              width: 100%;
              left: 0;
          }
          100% {
              width: 0;
              left: 100%;
          }
      }
      @keyframes move3 {
          0% {
              height: 100%;
              top: 0;
          }
          54% {
              height: 0;
              top: 100%;
          }
          55% {
              height: 0;
              top: 0;
          }
          100% {
              height: 100%;
              top: 0;
          }
      }
      @keyframes move4 {
          0% {
              width: 0;
              right: 0;
          }
          55% {
              width: 100%;
              right: 0;
          }
          100% {
              width: 0;
              right: 100%;
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/adjustmentBtn.vue